var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1998 8.9998C20.1998 10.7671 18.7672 12.1998 16.9998 12.1998C15.2324 12.1998 13.7998 10.7671 13.7998 8.9998C13.7998 7.23249 15.2324 5.7998 16.9998 5.7998C18.7672 5.7998 20.1998 7.23249 20.1998 8.9998Z",
    stroke: "#66B929",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6004 13.7998C26.6004 13.7998 20.9407 16.1998 17.0004 16.1998C13.06 16.1998 7.40039 13.7998 7.40039 13.7998",
    stroke: "#66B929",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0002 17V19.3235M17.0002 19.3235C17.0002 20.244 17.2648 21.145 17.7626 21.9192L21.8002 28.2M17.0002 19.3235C17.0002 20.244 16.7356 21.145 16.2378 21.9192L12.2002 28.2",
    stroke: "#66B929",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.14051C11.3534 1.77915 14.0858 1 17 1C25.8365 1 33 8.16344 33 17C33 25.8365 25.8365 33 17 33C8.16344 33 1 25.8365 1 17C1 14.0858 1.77915 11.3534 3.14051 9",
    stroke: "#66B929",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibility);
export default __webpack_public_path__ + "static/media/accessibility.2f49fa8053331c80062522909fadebd8.svg";
export { ForwardRef as ReactComponent };